import {useSuspenseQuery} from '@tanstack/react-query';

import {api} from '@/lib/ky';

import {assetSchema} from '../utils/schemas/asset';

import {assetKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getAssetByProject = async (id: string) => {
  const data = await api.get(`projects/${id}/asset`).json();
  return assetSchema.parse(data);
};

export const useAssetByProject = (
  id: string,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: assetKeys.detail(id),
    queryFn: () => getAssetByProject(id),
  });
};
export const useAssetByProjectLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getAssetByProject;
